package com.eladfinish.bible.contest.screens.mikud.usecases

import com.eladfinish.bible.contest.domain.catalog.BibleCatalog
import com.eladfinish.bible.contest.extensions.convertToDataClass
import com.eladfinish.bible.contest.screens.mikud.model.MikudData
import com.eladfinish.bible.contest.screens.mikud.model.RemoteMikudContent
import io.github.aakira.napier.Napier
import kotlinx.collections.immutable.toImmutableList
import kotlinx.serialization.SerializationException
import kotlinx.serialization.json.JsonElement
import kotlin.time.measureTime

class ParseMikudFromServerUseCase(
    private val populateBookUseCase: PopulateBookUseCase,
    private val buildBooksListUseCase: BuildBooksListUseCase,
) {

    operator fun invoke(remoteMikudContent: RemoteMikudContent): MikudData {
        val mikud = buildBooksListUseCase(full = false).toMutableList()
        measureTime {
            val bibleBooksEng = BibleCatalog.books.map { it.trans }
            remoteMikudContent.toList().forEach { pair ->
                val index = bibleBooksEng.indexOf(pair.first)
                val data: JsonElement =
                    pair.second.drop(1).first() // bamidbar=[36, [13,14]] - drop first and get new first (that was second)
                try {
                    data.toString().convertToDataClass<Int>()
                } catch (_: SerializationException) {
                    val chapters = data.toString().convertToDataClass<List<Int>>()
                    populateBookUseCase(
                        mikud = mikud,
                        index = index,
                        chapters = chapters,
                    )
                }
            }
        }.also {
            Napier.d("duration: $it")
        }
        return mikud.toImmutableList()
    }
}
